import './ConfigurationListingTableHeader.scss';

const ConfigurationListingTableHeader = () => {
  return (
    <div className="configurationListingTableHeader">
      <div className="tableField id">ID</div>
      <div className="tableField name">Nombre</div>
      <div className="tableField createdBy">Creado por</div>
      <div className="tableField class">Clase</div>
      <div className="tableField tools">Herramientas</div>
      <div className="tableField createdAt">Creación</div>
      <div className="tableField actions">Acciones</div>
    </div>
  );
};

export default ConfigurationListingTableHeader; 